import * as React from 'react';
import { Icon } from 'antd';
import { Route } from 'kts-platform-frame/routes';

const parentName: string = '/workbench/platform/network/user'; // 路由的跟节点；

Route.addNode(
    parentName, 
    { nodeName: '/workbench/platform/network-user-list-detail', path: '/workbench/platform/network/userlist/:id', title: ' 网络详情', component: require('./UI.Network.User.List.Detail').default},
    { nodeName: '/workbench/platform/network-user-list-default', exact: true, path: '/workbench/platform/network/userlist', title: '网络详情', component: require('./UI.Network.User.List.Default').default}
);

export default {
    getChildReact: (index?: string) => {
        return Route.getChildReact(parentName, index);
    },
    getNodeReact: (nodename: string) => {
        return Route.getNode(nodename);
    }
};

export {
    Switch
} from 'react-router-dom';



// WEBPACK FOOTER //
// ./src/display/platform/Network/Modules.Route.List.tsx